const connectTemplateTags = {
  connectTemplates: 'connectTemplates',
  connectTemplateCategories: 'connectTemplateCategories',
  connectTemplateDetails: 'connectTemplateDetails',
  linkedAssets: 'linkedAssets',
} as const;

export default connectTemplateTags;
